// @ts-nocheck
import React from "react";
import { VariationMenu } from "../../forecastGraphs/helpers/GraphMobileControls";

// Switches the variation of the active forecast — hourly values, speed, power. A dropdown rather than a eai-chip row because the count is schema-driven and some forecasts carry more variations than a toolbar row can hold.
const GraphVariationChips = ({ variations, forecastVariation, onVariationChange }) => {
  if (!variations || variations.length === 0) return null;
  return (
    <VariationMenu
      // Square below sm, where the label would push the row wide; utilities, since a component-layer class takes no variant
      buttonClassName="eai-btn-toolbar w-8 px-0 sm:w-auto sm:px-3"
      showLabel
      variationOptions={variations.map((v) => ({ key: v.key, label: v.name }))}
      selectedVariationKey={forecastVariation}
      onSelectVariation={onVariationChange}
    />
  );
};

export default GraphVariationChips;
